import { AlertComponent } from './alert/alert.component';
import { ButtonComponent } from './button/button.component';
import { LabelComponent } from './label/label.component';
import { ListComponent } from './list/list.component';
import { LoadingComponent } from './loading/loading.component';
import { PaginationComponent } from './pagination/pagination.component';
import { TextComponent } from './text/text.component';
import { ToastComponent } from './toast/toast.component';
import { TrueComponent } from './true/true.component';
import { UploadComponent } from './upload/upload.component';
import { UserListItemComponent } from './user-list-item/user-list-item.component';
import { ConversationComponent } from './conversation/main.component';
import { ChatComponent } from './conversation/chat/chat.component';
import { IconComponent } from './icon/icon.component';
import { CircularProgressComponent } from './circular-progress/circular-progress.component';
import { FilterComponent } from './filter/filter.component';
import { CardComponent } from './card/card.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { ImageValidatorComponent } from './image-validator/image-validator.component';
import { UserRegistrationComponent } from './user-registration/user-registration.component';
import { StepProgressComponent } from './step-progress/step-progress.component';
import { GuestGuard } from './user-registration/guest.guard';
import { DynamicFormComponent } from './dynamic-form/dynamic-form.component';
import { PhotoComponent } from './photo/photo.component';
import { ProfileComponent } from './profile/profile.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ConfirmPopupComponent } from './confirm-popup/confirm-popup.component';
import { ImageUploaderComponent } from './image-uploader/image-uploader.component';
import { OtherUserComponent } from './other-user/other-user.component';
import { ImageViewerComponent } from './image-viewer/image-viewer.component';

export * from './alert/alert.component';
export * from './list/list.component';
export * from './loading/loading.component';
export * from './loading/loading.service';
export * from './pagination/pagination.component';
export * from './text/text.component';
export * from './toast/toast.component';
export * from './toast/toast.service';
export * from './true/true.component';
export * from './upload/upload.component';
export * from './upload/upload.service';
export * from './auth/auth.component';
export * from './auth/auth.guard';
export * from './auth/rule.guard';
export * from './auth/auth.service';
export * from './user-list-item/user-list-item.component';
export * from './conversation/main.component';
export * from './conversation/main.service';
export * from './conversation/chat/chat.component';
export * from './conversation/chat/chat.service';
export * from './label/label.component';
export * from './button/button.component';
export * from './icon/icon.component';
export * from './circular-progress/circular-progress.component';
export * from './filter/filter.component';
export * from './card/card.component';
export * from './sidebar/sidebar.component';
export * from './image-validator/image-validator.component';
export * from './user-registration/user-registration.component';
export * from './user-registration/guest.guard';
export * from './step-progress/step-progress.component';
export * from './dynamic-form/dynamic-form.component';
export * from './photo/photo.component';
export * from './profile/profile.component';
export * from './reset-password/reset-password.component';
export * from './confirm-popup/confirm-popup.component';
export * from './image-uploader/image-uploader.component';
export * from './other-user/other-user.component';
export * from './image-viewer/image-viewer.component';

export const components = {
  AlertComponent,
  UserListItemComponent,
  ListComponent,
  LoadingComponent,
  PaginationComponent,
  TextComponent,
  ToastComponent,
  TrueComponent,
  UploadComponent,
  ChatComponent,
  LabelComponent,
  ButtonComponent,
  IconComponent,
  CircularProgressComponent,
  FilterComponent,
  CardComponent,
  SidebarComponent,
  ImageValidatorComponent,
  UserRegistrationComponent,
  GuestGuard,
  StepProgressComponent,
  DynamicFormComponent,
  PhotoComponent,
  ProfileComponent,
  ResetPasswordComponent,
  ConfirmPopupComponent,
  ImageUploaderComponent,
  OtherUserComponent,
  ImageViewerComponent,
  ConversationComponent
};
